import { Reservation } from '../../../../types/restaurant/RestaurantReservationTypes';
import ReservationActions from './ReservationActions';
import ReservationStatusBadge from './ReservationStatusBadge';

interface Props {
  reservations: Reservation[];
  toleranceMinutes: number;
  onEdit: (item: Reservation) => void;
  onConfirm: (item: Reservation) => void;
  onCancel: (item: Reservation) => void;
  onNoShow: (item: Reservation) => void;
  onOpenOrder: (item: Reservation) => void;
  isArrivalWindowOpen: (item: Reservation, tolerance: number) => boolean;
}

const dateTime = (value: string) =>
  new Intl.DateTimeFormat('es-SV', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));

const ReservationTable = ({
  reservations,
  toleranceMinutes,
  onEdit,
  onConfirm,
  onCancel,
  onNoShow,
  onOpenOrder,
  isArrivalWindowOpen,
}: Props) => (
  <div className="hidden overflow-x-auto md:block">
    <table className="w-full min-w-[1250px] table-auto">
      <thead>
        <tr className="border-b border-stroke bg-gray-2/60 text-left text-xs font-semibold uppercase tracking-wide text-bodydark2 dark:border-strokedark dark:bg-meta-4/30">
          <th className="px-4 py-4">Número</th>
          <th className="px-4 py-4">Fecha y hora</th>
          <th className="px-4 py-4">Invitado o cliente</th>
          <th className="px-4 py-4">Teléfono</th>
          <th className="px-4 py-4 text-center">Personas</th>
          <th className="px-4 py-4">Mesas</th>
          <th className="px-4 py-4">Estado</th>
          <th className="px-4 py-4">Activa/Histórica</th>
          <th className="px-4 py-4 text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {reservations.map((reservation) => (
          <tr
            key={reservation.id}
            className="border-b border-stroke last:border-0 dark:border-strokedark"
          >
            <td className="whitespace-nowrap px-4 py-4 font-semibold text-primary">
              {reservation.reservationNumber}
            </td>
            <td className="whitespace-nowrap px-4 py-4 text-sm text-black dark:text-white">
              {dateTime(reservation.startsAt)}
            </td>
            <td className="px-4 py-4 font-medium text-black dark:text-white">
              {reservation.customerName ||
                reservation.guestName ||
                'Cliente sin nombre'}
            </td>
            <td className="whitespace-nowrap px-4 py-4 text-sm text-bodydark2">
              {reservation.guestPhone || '—'}
            </td>
            <td className="px-4 py-4 text-center">{reservation.partySize}</td>
            <td className="px-4 py-4 text-sm text-bodydark2">
              {reservation.tables.map((table) => table.code).join(', ') ||
                'Sin mesa'}
            </td>
            <td className="px-4 py-4">
              <ReservationStatusBadge status={reservation.status} />
            </td>
            <td className="px-4 py-4">
              <span
                className={`rounded-full border px-2.5 py-1 text-xs font-semibold ${
                  reservation.active
                    ? 'border-success/20 bg-success/10 text-success'
                    : 'border-bodydark2/20 bg-bodydark2/10 text-bodydark2'
                }`}
              >
                {reservation.active ? 'Activa' : 'Histórica'}
              </span>
            </td>
            <td className="px-4 py-3">
              <ReservationActions
                reservation={reservation}
                arrivalWindowOpen={isArrivalWindowOpen(
                  reservation,
                  toleranceMinutes
                )}
                onEdit={() => onEdit(reservation)}
                onConfirm={() => onConfirm(reservation)}
                onCancel={() => onCancel(reservation)}
                onNoShow={() => onNoShow(reservation)}
                onOpenOrder={() => onOpenOrder(reservation)}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default ReservationTable;
